import { TextField, Button, Alert, Heading } from "@aws-amplify/ui-react";
import { Col, Form, Row } from "react-bootstrap";
import { Auth } from "aws-amplify";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import './login.css';

export function Signin({ onSignin }) {
  const navigate = useNavigate();
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");

  const [mode, setMode] = useState("signin"); 
  // signin | forgotPassword | resetPassword

  
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const showError = (message) => {
    setAlertMessage(message);
    setIsAlertVisible(true);
  };

  const clearAlert = () => {
    setAlertMessage("");
    setIsAlertVisible(false);
  };

  const signIn = async () => {
    clearAlert();

    try {
        const user = await Auth.signIn(username, password);
        console.log("Signed in user:", user);
        await onSignin();
        navigate('/')
    } catch (error) {
      console.log("Error signing in", error);
      showError("Error with username or password.");
    }
  };

  const sendResetCode = async () => {
    clearAlert();

    try {
      await Auth.forgotPassword(username);
      setMode("resetPassword");
    } catch (error) {
      console.log("Error sending reset code", error);
      showError(error.message || "Unable to send reset code.");
    }
  };

  const resetPassword = async () => {
    clearAlert();

    try {
      await Auth.forgotPasswordSubmit(username, code, newPassword);
      setMode("signin");
      setPassword("");
      setCode("");
      setNewPassword("");
      showError("Password reset successful. Please sign in with your new password.");
    } catch (error) {
      console.log("Error resetting password", error);
      showError(error.message || "Unable to reset password.");
    }
  };

  return (
    <div className="login">
      <Row className="justify-content-center">
        <Col lg={6} md={8}>
          <Form>
            {mode === "signin" && (
              <>
                <Heading level={3}>Sign In</Heading>

                <TextField
                  id="username"
                  label="Username"
                  value={username}
                  onChange={e => setUserName(e.target.value)}
                />

                <TextField
                  id="password"
                  label="Password"
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                />

                <Button
                  type="button"
                  id="signinButton"
                  onClick={signIn}
                  isFullWidth={true}
                >
                  Sign In
                </Button>

                <Button
                 type="button"
                  variation="link"
                  onClick={() => {
                    clearAlert();
                    setMode("forgotPassword");
                  }}
                >
                  Forgot Password?
                </Button>
              </>
            )}

            {mode === "forgotPassword" && (
              <>
                <Heading level={3}>Forgot Password</Heading>

                <TextField
                  id="forgot-username"
                  label="Username or Email"
                  value={username}
                  onChange={e => setUserName(e.target.value)}
                />

                <Button
                  type="button"
                  onClick={sendResetCode}
                  isFullWidth={true}
                >
                  Send Reset Code
                </Button>

                <Button
                  type="button"
                  variation="link"
                  onClick={() => {
                    clearAlert();
                    setMode("signin");
                  }}
                >
                  Back to Sign In
                </Button>
              </>
            )}

            {mode === "resetPassword" && (
              <>
                <Heading level={3}>Reset Password</Heading>

                <TextField
                  id="reset-username"
                  label="Username or Email"
                  value={username}
                  onChange={e => setUserName(e.target.value)}
                />

                <TextField
                  id="reset-code"
                  label="Confirmation Code"
                  value={code}
                  onChange={e => setCode(e.target.value)}
                />

                <TextField
                  id="new-password"
                  label="New Password"
                  type="password"
                  value={newPassword}
                  onChange={e => setNewPassword(e.target.value)}
                />

                <Button
                  type="button"
                  onClick={resetPassword}
                  isFullWidth={true}
                >
                  Reset Password
                </Button>

                <Button
                  type="button"
                  variation="link"
                  onClick={() => {
                    clearAlert();
                    setMode("signin");
                  }}
                >
                  Back to Sign In
                </Button>
              </>
            )}

            {isAlertVisible ? (
              <Alert variation={alertMessage.includes("successful") ? "success" : "error"}>
                {alertMessage}
              </Alert>
            ) : null}
          </Form>
        </Col>
      </Row>
    </div>
  );
}